/*=========================================================================================
  File Name: usersActions.js
  Description: Vuex Store - users actions
==========================================================================================*/

import axios from 'axios';
import state from '../state';

export default {
    /**
     *
     * @param commit
     * @returns {Promise<unknown>}
     */
    getTasks({commit}) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/tasks', method: 'GET'})
                .then(({data}) => {
                    resolve(data);
                });
        })
    },

    /**
     *
     * @param commit
     * @param payload
     * @returns {Promise<unknown>}
     */
    getNextTasks({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/tasks/next', data: payload, method: 'POST'})
                .then(({data}) => {
                    resolve(data);
                });
        })
    },

    /**
     *
     * @param commit
     * @param payload
     * @returns {Promise<unknown>}
     */
    saveTask({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/tasks/save', data: payload, method: 'POST'})
                .then(({data}) => {
                    resolve(data);
                }).catch(({response}) => {
                reject(response.data);
            });
        })
    },

    /**
     *
     * @param commit
     * @param payload
     * @returns {Promise<unknown>}
     */
    changeTask({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/tasks/edit', data: payload, method: 'POST'})
                .then(({data}) => {
                    resolve(data);
                }).catch(({response}) => {
                reject(response.data);
            });
        })
    },
};
